import { AxiosHelper } from '@/modules/shared/infra/protocols/http';

export async function openViaProxy(
  fileUrl: string,
  fileName: string,
  mode: 'download' | 'preview',
) {
  const base = AxiosHelper.getFullPath();
  const params = new URLSearchParams({ url: fileUrl, filename: fileName });
  const proxyUrl = `${base}v1/proxy_download?${params.toString()}`;

  const response = await fetch(proxyUrl, {
    headers: { Authorization: AxiosHelper.token ?? '' },
  });

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);

  if (mode === 'preview') {
    window.open(objectUrl, '_blank');
    // Revoga após tempo suficiente para o browser carregar o blob
    setTimeout(() => URL.revokeObjectURL(objectUrl), 30000);
  } else {
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(objectUrl);
  }
}
